var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPreRelease = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M7.872 0v1.211H3.028V0H1.817v1.211H1.21c-.672 0-1.205.545-1.205 1.211L0 10.9a1.21 1.21 0 0 0 1.211 1.211H9.69c.666 0 1.211-.545 1.211-1.211V2.422c0-.666-.545-1.21-1.211-1.21h-.606V0zm.606 6.661H5.45V9.69h3.028zM1.21 10.9H9.69V4.239H1.21z",
  clipRule: "evenodd"
})));
export default SvgPreRelease;